import { type FC } from 'react'

export interface RadioProps {
  checked: boolean,
  onChange?: (checked: boolean) => void,
  name?: string,
  value?: string,
  disabled?: boolean,
}

export const Radio: FC<RadioProps> = ({ checked, onChange, name, value, disabled = false }) => {
  const handleChange = () => {
    if (disabled) return
    onChange?.(!checked)
  }

  return (
    <div className='relative inline-flex items-center justify-center'>
      <input
        type='radio'
        className='sr-only'
        checked={checked}
        onChange={handleChange}
        name={name}
        value={value}
        disabled={disabled}
      />
      <div
        className={`w-5 h-5 rounded-full border-2 flex items-center justify-center
                  ${checked
            ? 'border-mi-bg-primary'
            : 'border-mi-text-gray'
          }
                  ${disabled ? 'opacity-50' : ''}`}
        onClick={handleChange}
      >
        {checked && (
          <div className='w-2.5 h-2.5 rounded-full bg-mi-bg-primary' />
        )}
      </div>
    </div>
  )
}
